import styled, { StyledProps } from 'styled-components/macro';

export type CircleButtonStylesProps = StyledProps<{}>;

export const CircleButton = styled.button<CircleButtonStylesProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: 0.3s;

  &:focus {
    border: none;
    outline: none;
  }
  &:hover {
    opacity: 0.8;
    border: none;
    outline: none;
  }
`;

export const ButtonIcon = styled.div<{ disabled?: boolean }>`
  width: 17px;
  height: 17px;
  border: 1px solid #0076c0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 3px;
  svg {
    color: #0076c0;
  }
  svg:hover {
    cursor: ${(props) => (props?.disabled ? 'unset' : 'pointer')};
  }
`;

export const ButtonTitle = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: #0076c0;
`;
